import React from 'react';
import ModalShell from './common/ModalShell';
import './ConfirmDialog.css';

export default function ConfirmDialog({ message, onConfirm, onCancel, confirmText = 'Confirm', cancelText = 'Cancel' }) {
  return (
    <ModalShell onClose={onCancel} overlayClassName="confirm-overlay">
      <div className="confirm-dialog" onClick={(e) => e.stopPropagation()}>
        <div className="confirm-message">{message}</div>
        <div className="confirm-actions">
          <button className="confirm-btn confirm-cancel" onClick={onCancel}>
            {cancelText}
          </button>
          <button className="confirm-btn confirm-submit" onClick={onConfirm}>
            {confirmText}
          </button>
        </div>
      </div>
    </ModalShell>
  );
}
